var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 456.78 150.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0b3a54;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.31,150.53c-8.06,0-11.97-4.33-11.97-12.82v-28.44l-9.34-.25v-.59l9.34-.17v-10.1l7.22-4.33h.42v14.43l16.3-.25v1.44l-16.3-.25v28.69c0,7.3,2.12,10.44,7.81,10.44,5.01,0,8.06-4.07,8.66-10.1l.68,.17c-.85,7.73-5.26,12.14-12.82,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.17,149.51h-7.64v-63.66h7.64v33.87c1.95-8.4,9-12.73,16.47-12.73,7.89,0,15.11,4.24,15.11,16.38v26.15h-7.64v-25.21c0-9.85-3.74-14.77-10.61-14.77-7.3,0-13.33,5.18-13.33,18.51v21.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.96,150.53c-11.12,0-20.63-7.72-20.63-21.56,0-13.07,8.4-21.99,20.97-21.99,11.63,0,18.76,8.32,18.76,19.44v.51h-31.66c.42,15.7,6.88,21.65,16.13,21.65,7.72,0,13.41-5.43,14.94-13.92l.76,.17c-2.04,10.87-9.25,15.7-19.27,15.7Zm-12.56-24.7h24.45c-.51-10.1-3.99-17.91-11.88-17.91-8.49,0-12.56,8.15-12.56,17.4v.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.59,149.51v-41.51h7.3v12.65c1.27-9.51,5.94-13.67,12.82-13.67,2.72,0,5.69,.93,7.72,2.46l-3.39,6.11c-2.29-2.38-5.09-3.73-8.32-3.73-6.37,0-8.49,5.94-8.49,11.63v26.06h-7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.91,141.19c-2.55,5.69-7.81,9.34-15.02,9.34-7.81,0-14.35-3.82-14.35-11.29,0-9.08,8.32-12.65,17.57-12.65,3.91,0,8.15,.85,11.54,2.38v-9.17c0-9.34-3.48-11.88-9.08-11.88s-9.34,3.73-11.29,12.56l-6.71-.59c2.8-8.23,9.51-12.9,18.25-12.9,9.68,0,16.55,3.82,16.55,17.15v25.38h-7.47v-8.32Zm-.25-4.67v-6.79c-3.31-1.7-6.88-2.21-9.59-2.21-6.88,0-11.71,3.99-11.71,10.78,0,6.37,3.99,10.27,10.36,10.27,4.75,0,10.95-4.16,10.95-12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.03,149.42v.08h-5.09l-14.6-41.51h8.15l12.05,37.94,11.21-32.51-1.87-5.43h8.15l11.63,37.86,12.56-37.86h1.78l-14.68,41.51-.08-.08v.08h-5.09l-11.71-34.04-12.31,34.04-.08-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.28,94.59c0-2.89,2.21-5.09,5.09-5.09s5.09,2.21,5.09,5.09-2.21,5.26-5.09,5.26-5.09-2.29-5.09-5.26Zm8.91,54.92h-7.64v-41.51h7.64v41.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.91,149.51h-7.64v-41.51h7.64v11.71c1.95-8.4,9-12.73,16.47-12.73,7.89,0,15.11,4.24,15.11,16.38v26.15h-7.64v-25.21c0-9.85-3.74-14.77-10.61-14.77-7.3,0-13.33,5.18-13.33,18.51v21.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.31,87.35s-12.71,9.16-19.58,17.37c-8.02,9.58-18.15,13.17-25.58,6.22-7.43-6.95-23.89-23.1-41.87-25.93,0,0,13.84,5.98,24.82,16.4,10.31,9.79,16.54,21.65,16.54,33.2,0,10.26-8.78,14.46-8.78,14.46h27.43s-4.39-33.93,27.01-61.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 408.7,
    cy: 103.75,
    rx: 8.23,
    ry: 7.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M435.53,83.36c3.25-8.09,3.91-16.21,2.34-22.62-5.65,3.75-10.85,10.2-14.1,18.29-3.25,8.09-3.91,16.21-2.34,22.62,5.65-3.75,10.85-10.2,14.1-18.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.87,68.12c4.03-5.06,6.68-12.39,6.93-20.62,.25-8.23-1.95-15.7-5.66-20.97-4.03,5.06-6.68,12.39-6.93,20.62-.25,8.23,1.95,15.7,5.66,20.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.99,71c-.61-9.06-3.3-17.08-7.09-22.56-3.03,5.9-4.62,14.18-4.01,23.24,.61,9.06,3.3,17.08,7.09,22.56,3.03-5.9,4.62-14.18,4.01-23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.81,56.53c-5.39-8.4-12.22-14.8-18.77-18.22,.21,7.13,3.08,15.86,8.47,24.27,5.39,8.4,12.22,14.8,18.77,18.22-.21-7.13-3.08-15.86-8.47-24.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.96,70.81c-2.35,3.3-3.82,8.03-3.82,13.28s1.47,9.98,3.82,13.28c2.35-3.3,3.82-8.03,3.82-13.28s-1.47-9.98-3.82-13.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.02,98.56c-2.62,3.65-3.95,7.61-3.96,10.97,3.27-1.22,6.65-3.84,9.27-7.49,2.62-3.65,3.95-7.61,3.96-10.97-3.27,1.22-6.65,3.84-9.27,7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.87,51.92c-3.88,1.5-7.42,4.61-9.61,8.87-2.19,4.27-2.59,8.85-1.45,12.7,3.88-1.5,7.42-4.61,9.61-8.87,2.19-4.27,2.59-8.85,1.45-12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.27,50.58c.99-2.23,1.07-4.92,0-7.46-1.06-2.54-3.06-4.44-5.38-5.4-.99,2.23-1.07,4.92,0,7.46,1.06,2.54,3.06,4.44,5.38,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.33,57.87c2.59-3.19,4.15-7.72,4.01-12.69-.14-4.98-1.94-9.41-4.71-12.47-2.59,3.19-4.15,7.72-4.01,12.69,.14,4.98,1.94,9.41,4.71,12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M431.31,38.45c2.1-3.14,2.98-7.26,2.13-11.5-.85-4.24-3.27-7.75-6.43-9.92-2.1,3.14-2.98,7.26-2.13,11.5,.85,4.24,3.27,7.75,6.43,9.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.76,49.54c1.46,5.1,4.4,9.27,7.9,11.79,1.66-3.88,1.97-8.9,.5-14-1.46-5.1-4.4-9.27-7.91-11.79-1.66,3.88-1.97,8.9-.5,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.32,33.37c1.6,5.57,4.8,10.11,8.62,12.87,1.82-4.23,2.14-9.71,.55-15.28-1.6-5.57-4.8-10.11-8.62-12.87-1.82,4.24-2.14,9.71-.55,15.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.94,96.34c1.06-9.26-1.52-20.14-7.92-30.17-6.4-10.02-15.34-17.18-24.43-20.51-1.06,9.26,1.52,20.14,7.92,30.17,6.4,10.02,15.34,17.18,24.43,20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.31,23.9c5.23,3.84,11.06,5.9,16.12,6.08-1.51-4.63-5.11-9.47-10.34-13.31-5.23-3.84-11.06-5.9-16.12-6.08,1.51,4.63,5.11,9.47,10.34,13.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.86,80.35c8.12,2.83,16.25,3.22,22.66,1.55-3.78-5.22-10.27-9.93-18.39-12.76-8.12-2.83-16.25-3.22-22.66-1.55,3.78,5.22,10.27,9.93,18.39,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.91,90.8c-6.35-2.22-12.72-2.52-17.73-1.21,2.96,4.09,8.04,7.77,14.39,9.99,6.35,2.22,12.72,2.52,17.73,1.21-2.96-4.09-8.04-7.77-14.39-9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.84,77.84c-6.82-2.08-13.61-2.01-18.92-.22,3.25,4.4,8.75,8.21,15.57,10.29,6.82,2.08,13.61,2.01,18.92,.22-3.25-4.4-8.75-8.21-15.57-10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.72,58.14c-1.69-5.84-5.27-10.55-9.6-13.35-2.21,4.53-2.73,10.33-1.04,16.17,1.69,5.84,5.27,10.55,9.6,13.35,2.21-4.53,2.73-10.33,1.04-16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.11,40.74c1.31-4.1,.45-8.39-1.97-11.91-4.07,1.63-7.28,4.72-8.59,8.82-1.31,4.1-.45,8.39,1.97,11.91,4.07-1.63,7.28-4.72,8.59-8.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.65,50.1c-.29-5.69-2.27-10.73-5.21-14.18-2.58,3.7-4.05,8.9-3.76,14.59,.29,5.69,2.27,10.73,5.21,14.18,2.58-3.7,4.05-8.9,3.76-14.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.12,31.38c3.26-1.08,5.82-3.08,7.28-5.38-2.63-.94-5.94-.98-9.2,.1-3.26,1.08-5.82,3.08-7.28,5.38,2.64,.94,5.94,.98,9.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.46,4.52C368,1.73,361.61-.01,354.52,0c-7.09,.01-13.47,1.78-17.91,4.58,4.46,2.79,10.84,4.53,17.93,4.52,7.09-.01,13.47-1.78,17.91-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.77,17.27c3.26-3.63,4.8-8.03,4.62-12.13-4.26,.45-8.58,2.57-11.84,6.2-3.26,3.63-4.8,8.03-4.62,12.13,4.26-.45,8.58-2.57,11.84-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.51,35c-4.71,3.63-8.92,9.63-11.42,16.98-2.5,7.35-2.78,14.57-1.21,20.16,4.71-3.63,8.92-9.63,11.42-16.98,2.5-7.34,2.78-14.57,1.21-20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331,35.2c2.8-2.43,5.16-6.31,6.34-10.96,1.18-4.64,.96-9.13-.35-12.52-2.8,2.43-5.16,6.31-6.34,10.96-1.19,4.64-.96,9.13,.35,12.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.09,11.85c-1.8,5.4-1.81,12.42,.39,19.59,2.2,7.18,6.18,13.07,10.74,16.68,1.8-5.4,1.81-12.42-.39-19.59-2.2-7.18-6.18-13.07-10.74-16.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.26,11.85c.82,6.04,4.16,12.87,9.72,18.89,5.56,6.02,12.24,10.02,18.4,11.54-.82-6.04-4.16-12.87-9.72-18.89-5.56-6.02-12.24-10.02-18.4-11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.85,22.41c-.29,1.72,.08,3.77,1.17,5.7,1.09,1.93,2.69,3.35,4.35,4.05,.29-1.72-.08-3.77-1.17-5.7-1.09-1.93-2.69-3.35-4.35-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.37,21.1c-1.64-.27-3.6,.03-5.45,.97-1.85,.94-3.22,2.32-3.91,3.76,1.64,.27,3.6-.03,5.45-.97,1.85-.94,3.22-2.32,3.91-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.71,95.61c.57-1.8,.49-4.05-.38-6.26-.87-2.22-2.37-3.96-4.04-4.95-.57,1.8-.49,4.05,.38,6.26,.87,2.22,2.37,3.96,4.04,4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.38,91.62c1.73,.95,3.72,1.1,5.49,.56-.4-1.74-1.53-3.31-3.26-4.26-1.73-.95-3.72-1.1-5.49-.56,.4,1.74,1.53,3.31,3.26,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.09,10.44c1.85,.93,3.82,1.24,5.45,.96-.69-1.45-2.06-2.83-3.91-3.76-1.85-.93-3.82-1.24-5.45-.96,.69,1.45,2.06,2.83,3.91,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.29,46.91c.57-3.26-.12-7.16-2.18-10.83-2.06-3.67-5.08-6.37-8.23-7.72-.57,3.26,.12,7.16,2.18,10.83,2.06,3.67,5.08,6.37,8.23,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.82,85.33c-.38-3.78-2.36-7.91-5.78-11.4-3.42-3.49-7.61-5.63-11.52-6.23,.38,3.78,2.36,7.91,5.78,11.4,3.42,3.49,7.61,5.63,11.52,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.35,33.68c.26,2.55,1.59,5.33,3.9,7.68,2.31,2.35,5.13,3.8,7.77,4.2-.26-2.55-1.59-5.33-3.9-7.68-2.31-2.35-5.13-3.8-7.77-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.69,56.93c3.76,4.07,8.13,6.89,12.07,8.11-.78-3.89-3.17-8.39-6.92-12.46-3.76-4.07-8.13-6.89-12.07-8.11,.78,3.89,3.17,8.39,6.92,12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.33,18.42c2.76,1.77,5.8,2.56,8.43,2.39-.84-2.39-2.76-4.79-5.52-6.56-2.76-1.77-5.8-2.56-8.43-2.39,.84,2.39,2.76,4.79,5.52,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.77,19.85c3.34-2.19,5.65-5.14,6.64-8.06-3.21-.17-6.91,.83-10.25,3.02-3.34,2.19-5.65,5.14-6.64,8.06,3.21,.17,6.91-.83,10.25-3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.21,71c1.32-2.44,1.87-5.74,1.32-9.24-.55-3.5-2.08-6.51-4.09-8.47-1.32,2.44-1.87,5.74-1.32,9.24,.55,3.5,2.08,6.51,4.09,8.47Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithName);
export default __webpack_public_path__ + "static/media/logoWithName.c688777020c73fa21e944e306b65830b.svg";
export { ForwardRef as ReactComponent };